import { ChangeDetectionStrategy, Component, input } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import { NgSharedModule, TypedFormGroup } from '@principle-theorem/ng-shared';
import {
  MohHighCariesProviderData,
  MohHighCariesRequestReason,
} from '@principle-theorem/principle-core/interfaces';
import { NgMaterialModule } from '@principle-theorem/ng-material';
import { getEnumValues } from '@principle-theorem/shared';

@Component({
  selector: 'pr-moh-high-caries-request-form',
  imports: [ReactiveFormsModule, NgMaterialModule, NgSharedModule],
  templateUrl: './moh-high-caries-request-form.component.html',
  styleUrl: './moh-high-caries-request-form.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class MohHighCariesRequestFormComponent {
  form = input.required<TypedFormGroup<MohHighCariesProviderData>>();

  requestReasonLabelMap: Record<MohHighCariesRequestReason, string> = {
    [MohHighCariesRequestReason.YearNine]: 'In Year 9 and has left the COHS.',
    [MohHighCariesRequestReason.ExtendedPeriod]:
      'Has not attended the COHS or another health provider for an extended period of time.',
    [MohHighCariesRequestReason.RecentlyEntered]:
      'Recently entered New Zealand.',
    [MohHighCariesRequestReason.RiskChanged]: `Individual's caries risk has changed`,
  };
  requestReasons = getEnumValues(MohHighCariesRequestReason);
}
